import React, { Fragment } from 'react';
import LeadCard from './LeadCard';
import GenerationCard from './GenerationCard';
import Note from './Note';

const ResultsList = ({
  results,
  extractToJson,
  handleClearResults,
  expandedPermalink,
  handleRowClick,
  ...generationProps
}) => {
  return (
    <div className="results-screen" data-testid="resultList-resultsScreen">
      <Note />
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-[#022B3A] dark:text-[#FFFFFF]">Found {results.length} qualified leads</h2>
        <div className="flex items-center gap-4">
          <button onClick={extractToJson} className="bg-[var(--color-primary-accent)] text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 hover:bg-[var(--color-primary-accent-hover)] transition-colors" data-testid="resultList-saveToJsonButton">
            <span className="material-icons-outlined text-base">download</span>
            Save to JSON
          </button>
          <button onClick={handleClearResults} className="bg-[var(--color-primary-accent)] text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 hover:bg-[var(--color-primary-accent-hover)] transition-colors" data-testid="resultList-clearResultsButton">
            <span className="material-icons-outlined text-base">delete</span>
            Clear Results
          </button>
        </div>
      </div>
      <div className="space-y-6">
        {results.map((result) => (
          <Fragment key={result.permalink}>
            <LeadCard
              result={result}
              handleRowClick={handleRowClick}
              isExpanded={expandedPermalink === result.permalink}
            />
            {expandedPermalink === result.permalink && (
              <GenerationCard
                result={result}
                {...generationProps}
              />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default ResultsList;